/** @format */

import { EnumItem } from "interfaces";
import _ from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input, Label } from "semantic-ui-react";
import { data } from "services";
import Entity from "./entity";

export default function ArrayEntities({
  value,
  onChange,
  gridName,
  displayField,
}: {
  value: number[];
  onChange: Function;
  gridName: string;
  displayField?: string;
}) {
  const { t } = useTranslation();
  function change(v: number[]) {
    if (onChange) {
      onChange(v);
    }
  }
  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {value?.map((i: number, index: number) => (
          <div className="w-56">
            <div className="flex justify-between">
              <span className="ml-2 text-sm font-semibold">
                Index: {index + 1}
              </span>
              <span
                className="text-red-700 cursor-pointer text-sm font-bold"
                onClick={() => {
                  let tmp = _.cloneDeep(value);
                  tmp.splice(index, 1);
                  change(tmp);
                }}
              >
                Remove
              </span>
            </div>
            <Entity
              gridName={gridName}
              value={i}
              values={[i]}
              displayField={"name"}
              onChange={(val: number) => {
                console.log({ value });
                let tmp = _.cloneDeep(value);
                tmp[index] = Number(val);
                change(tmp);
              }}
            />
            {/* <Input
              value={i}
              onChange={(evt: any) => {
                let tmp = _.cloneDeep(value);
                tmp[index] = Number(evt.target.value);
                change(tmp);
              }}
            /> */}
          </div>
        ))}
      </div>

      <div className="mt-2">
        <Button
          className="mt-2"
          content="Add"
          icon="plus"
          color="blue"
          onClick={() => {
            let tmp = _.cloneDeep(value);
            tmp.push(0);
            change(tmp);
          }}
        />
      </div>
    </div>
  );
}
